"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlugins = getPlugins;
const debugHelper_1 = require("./lib/debugHelper");
const userAttributes_1 = require("./plugins/userAttributes");
const deviceAttributes_1 = require("./plugins/deviceAttributes");
const sessionId_1 = require("./plugins/sessionId");
const teamName_1 = require("./plugins/teamName");
const campaignAttributes_1 = require("./plugins/campaignAttributes");
const wordpressGenericTrackingData_1 = require("./plugins/wordpressGenericTrackingData");
const addGenericTrackingData_1 = require("./plugins/addGenericTrackingData");
const addCriteoProductData_1 = require("./plugins/addCriteoProductData");
const transformDenyAll_1 = require("./plugins/transformDenyAll");
const afterHook_1 = require("./plugins/afterHook");
const filterResumeHash_1 = require("./plugins/filterResumeHash");
function getPlugins(options) {
    const { teamName, sessionCookieDomain, debug } = options;
    const plugins = getDefaultPlugins();
    if (sessionCookieDomain) {
        plugins.push((0, sessionId_1.createSessionIdPlugin)(sessionCookieDomain));
    }
    else {
        (0, debugHelper_1.debugLog)(options, 'Skipping session plugin, no session cookie domain set');
    }
    if (teamName) {
        plugins.push((0, teamName_1.createTeamNamePlugin)(teamName));
    }
    if (options.teamName === 'wordpress') {
        plugins.push(wordpressGenericTrackingData_1.wordpressGenericTrackingDataPlugin);
    }
    (0, debugHelper_1.debugLog)(options, 'Using plugins:', plugins);
    return plugins;
}
function getDefaultPlugins() {
    const plugins = [
        transformDenyAll_1.transformDenyAllPlugin,
        userAttributes_1.userAttributesPlugin,
        deviceAttributes_1.deviceAttributesPlugin,
        campaignAttributes_1.campaignAttributesPlugin,
        addGenericTrackingData_1.addGenericTrackingDataPlugin,
        addCriteoProductData_1.addCriteoProductDataPlugin,
        afterHook_1.afterHookPlugin,
        filterResumeHash_1.filterResumeHashPlugin,
    ];
    return plugins;
}
//# sourceMappingURL=plugins.js.map